import React, { Component } from 'react';
import '../global';
import { connect } from 'react-redux';
import { getProfileForm } from '../actions';
import Loading from '../../components/loading-component';

class Profile extends Component {
	constructor(props) {
		super(props);
		this.profile_form = getMyAccountObj().profile_form;
		this.business_profile = getMyAccountObj().business_profile;
		this.state = {
			active: 'personal_profile'
		}
	}

	componentWillMount() {
		this.props.getProfileForm();
	}

	render() {
		
		const active = this.state.active;
		return (
			<div>
				<ul className="nav nav-tabs">
					<li onClick={() => this.setState({ active: 'personal_profile' })} className={"nav-item " + (active === 'personal_profile' ? 'active' : '')} name="Personal Profile" role="tab" aria-controls="personal-profile" aria-selected="true">Personal Profile</li>
					<li onClick={() => this.setState({ active: 'business_profile' })} className={"nav-item " + (active === 'business_profile' ? 'active' : '')} name="Business Profile" role="tab" aria-controls="business-profile" aria-selected="true">Business Profile</li>
				</ul>
				{active === 'personal_profile' && (
				<div className="profile-form-banner">
					<i className="fa fa-info-circle" aria-hidden="true"></i>
					<p>Changing your personal information will also change your billing address for purchases made through ISDA.org.</p>
					</div>
				)}
				{this.props.loading ? (
					<Loading width={'100%'} height={100} />
				) : (
					<div className="tab-content">
						{this.props.profileForm && (
							<div style={{ display: active === 'personal_profile' ? 'block' : 'none' }} dangerouslySetInnerHTML={{ __html: this.props.profileForm.profile_form }} />
						)}
						{this.props.profileForm && (
							<div style={{ display: active === 'business_profile' ? 'block' : 'none' }} dangerouslySetInnerHTML={{ __html: this.props.profileForm.business_profile }} />
						)}
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	profileForm: state.profileForm,
	loading: state.loading,
});

export default connect(mapStateToProps, { getProfileForm })(Profile);	